<div #estimatedDevelopmentWrapper class="portfolio-box">
  <h2 class="ui-headline">{{ 'new_strategy.portfolio_screen.graph_box.title' | translate }}</h2>
  <p
    *ngIf="investmentData.monthly_investment; else withoutSavingsPlan"
    [innerHtml]="
      'new_strategy.portfolio_screen.graph_box.p4'
        | translate
          : {
              currentInvestment: investmentData.total | translateNumber: customer.language:investmentData.currency,
              monthlySavingsPlan: investmentData.monthly_investment | translateNumber: customer.language:investmentData.currency,
              riskType: 'new_strategy.risk_screen.slider.active.' + riskName | translate | lowercase
            }
    "
  ></p>
  <div class="expected">
    <div class="year-selector">
      <p>{{ 'invest.value_after' | translate }}&ensp;</p>
      <select class="year-select" (change)="calculateExpectedReturn($event.target.value)">
        <option *ngFor="let year of [1, 5, 10, 15, 20]" [value]="year" [selected]="yearsPicked === year">
          {{ year }}
          {{
            year === 1 ? ('invest.years' | translate).slice(0, customer.language.includes('de-') ? -2 : -1) : ('invest.years' | translate)
          }}
        </option>
      </select>
    </div>
    <h4 class="ui-headline">{{ expectedReturn | translateNumber: customer.language:investmentData.currency }}</h4>
  </div>
  <ng-template #withoutSavingsPlan>
    <p
      class="estimated-development-subtitle"
      [innerHtml]="
        'new_strategy.portfolio_screen.graph_box.p5'
          | translate
            : {
                currentInvestment: investmentData.total | translateNumber: customer.language:investmentData.currency,
                riskType: 'new_strategy.risk_screen.slider.active.' + riskName | translate | lowercase
              }
      "
    ></p>
  </ng-template>
  <app-strategy-stacked-area-chart
    *ngIf="chartData && chartData?.data?.length && chartConfig"
    [data]="chartData"
    [customerLanguage]="customer.language"
    [investedByYear]="chartDataInvestedByYear"
    [config]="chartConfig"
    [translations]="{
      badCase: ('new_strategy.portfolio_screen.graph.columns.bad' | translate),
      expectedCase: ('new_strategy.portfolio_screen.graph.columns.expected' | translate),
      goodCase: ('new_strategy.portfolio_screen.graph.columns.good' | translate),
      year: ('new_strategy.portfolio_screen.graph_box.tooltip.year' | translate),
      investment: ('new_strategy.portfolio_screen.graph_box.tooltip.investment' | translate),
      expectedValue: ('new_strategy.portfolio_screen.graph_box.tooltip.expectedValue' | translate)
    }"
  ></app-strategy-stacked-area-chart>
  <div class="balance-box">
    <p *ngIf="!showMore" class="show-more">
      <a (click)="toggleShowMore(true)">{{ 'strategy.show_more' | translate }}</a>
    </p>
    <ng-container *ngIf="showMore">
      <p class="show-more">
        <a (click)="toggleShowMore(false)">{{ 'strategy.show_less' | translate }}</a>
      </p>
      <div class="expected-return-holder">
        <h4 class="ui-headline">{{ 'strategy.show_more_yearly' | translate }}</h4>
        <div>
          <p
            *ngFor="
              let expectation of [
                ['rb_return', expectedReturnRatio],
                ['rb_gain', expectedPotentialRatio],
                ['rb_loss', expectedLossRatio]
              ];
              let i = index
            "
            class="expectation"
          >
            {{ 'risk.' + expectation[0] | translate }}
            <span *ngIf="i !== 2">+</span>{{ expectation[1] * 100 | translatePercent: customer.language }}
          </p>
        </div>
        <p
          [innerHTML]="
            'risk.box.probability'
              | translate
                : {
                    expectedLossRatio: expectedLossRatio * 100 | translatePercent: customer.language,
                    expectedPotentialRatio: expectedPotentialRatio * 100 | translatePercent: customer.language,
                    expectedReturnRatio: expectedReturnRatio * 100 | translatePercent: customer.language
                  }
          "
        ></p>
      </div>
      <div class="expected-return-holder">
        <h4 class="ui-headline">{{ 'portfolio.estimatedAssetDevelopment.h3.calculation' | translate }}</h4>
        <p>{{ 'new_strategy.portfolio_screen.graph_box.disclaimer' | translate }}</p>
      </div>
    </ng-container>
  </div>
</div>
